module.exports = __webpack_public_path__ + "static/media/costPrice.845e0eb6.mp3";